import {Point2D} from './geometry';
import {CUtilit} from './utilit';

export class CUtilitDrawing {
  public static drawArrow(path: Path2D, arrowStart: Point2D, arrowEnd: Point2D, arrowSize: number = 5, doubleArrow: boolean = false) {

    function drawTip(startTip: Point2D, endTip: Point2D) {
      path.moveTo(startTip.X + 0.5 * tipOffset.Y, startTip.Y - 0.5 * tipOffset.X);
      path.lineTo(startTip.X - 0.5 * tipOffset.Y, startTip.Y + 0.5 * tipOffset.X);
      path.lineTo(endTip.X, endTip.Y);
      //path.lineTo(startTip.X + 0.5 * tipOffset.Y, startTip.Y - 0.5 * tipOffset.X);
      path.closePath();
    }
    const normal: Point2D = arrowEnd.subtract(arrowStart).normalize();
    const startToEndDistance = arrowStart.distance(arrowEnd);
    const tipOffset: Point2D = normal.multiply((arrowSize / startToEndDistance) * startToEndDistance) ;
    const endBeforeTip: Point2D = arrowEnd.subtract(tipOffset);
    if (doubleArrow) {
      const startBeforeTip: Point2D = arrowStart.add(tipOffset);
      path.moveTo(startBeforeTip.X, startBeforeTip.Y);
      path.lineTo(endBeforeTip.X, endBeforeTip.Y);
      drawTip(endBeforeTip, arrowEnd);
      drawTip(startBeforeTip, arrowStart);
    } else {
      path.moveTo(arrowStart.X, arrowStart.Y);
      path.lineTo(endBeforeTip.X, endBeforeTip.Y);
      drawTip(endBeforeTip, arrowEnd);
    }
  }

  public static drawBoxText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, rotation: number = 0, surroundingRectangle: boolean = false) {
    ctx.save();
    const fontMetrics = ctx.measureText(text);
    const actualHeight = fontMetrics.actualBoundingBoxAscent + fontMetrics.actualBoundingBoxDescent;
    const fontHeight = fontMetrics.fontBoundingBoxAscent + fontMetrics.fontBoundingBoxDescent;
    const fontWidth = fontMetrics.width;
    const paddingX = 1 + (6 * 2);
    const paddingY = 1 + (6 * 2);

    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    // Border
    ctx.translate(x, y);
    ctx.rotate(CUtilit.degToRadian(rotation));
    ctx.clearRect(-fontWidth / 2 - paddingX / 2,
      -fontHeight / 2 - paddingY / 2,
      fontWidth + paddingX,
      actualHeight + paddingY);
    if (surroundingRectangle) {
      ctx.strokeRect(-fontWidth / 2 - paddingX / 2,
        -fontHeight / 2 - paddingY / 2,
        fontWidth + paddingX,
        actualHeight + paddingY);
    }
    ctx.fillText(text, - fontWidth / 2, - fontHeight / 2);
    ctx.restore();
  }
}
